<template>
  <div>
    <Header current="build" active="development"></Header>
    <div class="development">
      <div class="start con">
        <h3>{{ $t('lang.dev.start') }}</h3>
        <p class="f12">{{ $t('lang.dev.details') }}</p>
        <button class="btn" @click="gotoLink(dev.get_start)">{{ $t('lang.dev.btn') }}</button>
      </div>
      <div class="partner">
        <div class="list con">
          <div class="item" v-for="(item, index) of list" :key="index">
            <h5>{{ item.title }}</h5>
            <div @click="gotoLink(item.link)">
              <img :src="item.url" />
            </div>
            <p class="f12">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { home, dev } from "../../common/link.js";
export default {
  name: "Development",
  components: {
    Header,
  },
  data() {
    return {
      list: [],
      home,
      dev,
    };
  },
  created() {
    localStorage.setItem("url", "development");
    this.list = [
      {
        title: this.$t("lang.dev.docs"),
        url: require("../../assets/images/d1.png"),
        text: this.$t("lang.dev.docDetails"),
        link: dev.dev_docs,
      },
      {
        title: this.$t("lang.dev.github"),
        url: require("../../assets/images/d2.png"),
        text: this.$t("lang.dev.githubDetails"),
        link: dev.github,
      },
      {
        title: this.$t("lang.dev.testnet"),
        url: require("../../assets/images/d3.png"),
        text: this.$t("lang.dev.testnetDetails"),
        link: dev.free_dna,
      },
      {
        title: this.$t("lang.dev.whitepaper"),
        url: require("../../assets/images/d4.png"),
        text: this.$t("lang.dev.whitepaperDetails"),
        link: home.whitepaper,
      },
    ];
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.development {
  margin-top: 0.96rem;

  .start {
    h3 {
      title();
      margin-bottom: 0.25rem;
    }

    p {
      text();
      margin-bottom: 0.5rem;
    }

    .btn {
      width: 2.23rem;
      height: 0.6rem;
    }
  }

  .partner {
    background-color: $otherColor;

    .list {
      font-size: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .item {
      margin-bottom: 1rem;

      h5 {
        title();
      }

      div {
        width: 4.91rem;
        height: 2.15rem;
        cursor: pointer;

        img {
          width: 100%;
        }
      }

      p {
        width: 4.91rem;
        text();
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .development {
    padding-top: 40px;

    .partner {
      .list {
        display: block;
      }

      .item {
        h5 {
          font-size: 14px;
          margin-bottom: 5px;
        }

        div {
          width: 100%;
          height: auto;
        }

        p {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/build/Development.vue